const stableIcon = new URL(
  '/public/new-image/aimarket/algorithm-1.png',
  import.meta.url
)

const data = {
  massageRobot: {
    name: 'industry.massageRobot',
    banner: new URL(
      '/public/image/industry_solution/robot-banner.png',
      import.meta.url
    ),
    scheme_dec: 'industry.robotDec',
    scheme_banner: new URL(
      '/public/image/industry_solution/scheme-banner.png',
      import.meta.url
    ),
    technical: '',
    technical_banner: [
      new URL(
        '/public/image/industry_solution/robot-technical-1.png',
        import.meta.url
      ),
    ],
    clientTitle: 'industry.robotClientTitle',
    client: 'industry.robotClientDec',
    client_banner: new URL(
      '/public/image/industry_solution/robot-client.png',
      import.meta.url
    ),
  },
  intelligentSorting: {
    name: 'industry.IntelligentSorting',
    banner: new URL(
      '/public/image/industry_solution/Intelligent-banner.png',
      import.meta.url
    ),
    scheme_dec: 'industry.intelligentDec',
    scheme_banner: new URL(
      '/public/image/industry_solution/intelligent-scheme.png',
      import.meta.url
    ),
    technical: 'industry.intelligentTechnical',
    technical_banner: [
      new URL(
        '/public/image/industry_solution/intelligent-technical-1.png',
        import.meta.url
      ),
    ],
    clientTitle: 'industry.intelligentClientTitle',
    client: 'industry.intelligentClientDec',
    client_banner: new URL(
      '/public/image/industry_solution/intelligent-client.png',
      import.meta.url
    ),
  },
}

const childItem = {
  smartRetail: {
    name: 'industry.intelligentVending',
    banner: new URL(
      '/public/image/industry_solution/retail.png',
      import.meta.url
    ),
    scheme_dec: 'industry.retailDec',
    scheme_banner: new URL(
      '/public/new-image/industry/retail-1.jpg',
      import.meta.url
    ),
    scheme_dec2:
      '从第四代至第六代售货机，物联网技术的应用愈发显著，均以AI视觉为核心。其中，第六代技术凭借其强大的边缘计算能力，在降低网络依赖、实现快速识别结算、提升系统稳定性及降低成本等方面取得了重大突破，成为当前行业发展的主流方向。',
    technical: 'industry.retailTechnical',
    pectorophonyScheme:
      '<b style="color:#ff0000"><h3>移远AI智能无人零售解决方案：重塑高效零售新体验</h3></b><br>移远通信OpenVending AI智能无人零售解决方案深度融合了高性能5G AI算力模组SG560D与前沿商品识别算法，结合创新的上新平台等软硬件服务，拥有卓越的动态视觉感知与强大边缘计算能力。<br>该方案支持与客户应用程序无缝对接，提供从终端到平台的全栈技术和服务支持，不仅助力客户实现降本增效，更推动智能零售行业持续升级，迈向更智能、更高效的未来。<br><br><b style="color:#ff0000"><h3>五大核心优势 助力降本增效</h3></b><br>相较于目前市面上的其他AI智能无人零售解决方案，移远通信的方案具有多重核心优势。<br><br><b style="color:#1a1a1a">■ 本地算力平台支持</b><br>移远通信的AI智能无人零售解决方案不仅支持SG560D模组搭载的QCM6490平台，还可适配多种算力平台。依托自研AI模组与算法技术积累，该方案对硬件推理性能进行了深度优化，能够高效处理实时动态视频流，实现无延迟计算，显著提升系统整体表现。<br><br><b style="color:#1a1a1a">■ 海量SKU支持，模型能力在线升级</b><br>移远AI智能无人零售解决方案经过海量数据的深度训练，具备更强的模型泛化能力，可精准识别上千种商品。同时，可根据实际应用场景的需求，灵活提供大、中、小等不同尺寸的模型。此外，移远方案支持定期在线升级模型能力，不断拓展可识别商品的种类，以满足市场的动态变化。<br><br><b style="color:#1a1a1a">■ 全链路精准识别，准确率高达99%</b><br>该方案采用单/双摄像头+智能算法识别等多重机制，并结合重量等数据进行交叉验证，大幅降低了误判率，可实现高达99%的端到端识别准确率。<br><br><b style="color:#1a1a1a">■ 异常行为报警，运营管理更智能</b><br>基于移远识别算法的高精度监测与AI算力模组的稳定传输能力，该方案可在商品错拿、遮挡等异常场景中实现实时告警，打造全链路实时化能力。客户亦可按需自定义异常场景，有效降低异常行为对日常运营的影响。 <br><br><b style="color:#1a1a1a">■ 高效迭代与低成本部署</b><br>在传统模式下，商品更新往往需要耗费数日时间，而采用移远方案可将这一时间缩短至几分钟，大幅提高了客户的运营效率。同时，该方案在保证高性能的前提下，实现了低成本部署，为客户提供了更具性价比的解决方案。',
    pectorophonyImg: [
      new URL('/public/new-image/industry/retail-2.jpg', import.meta.url),
    ],
    pectorophonyApply: [
      {
        name: '智慧零售',
        dec: '在医院、高铁站、景区等高人流量、高要求的复杂环境中，实现快速识别结算。',
        img: new URL(
          '/public/new-image/industry/retail-4.jpg',
          import.meta.url
        ),
      },
    ],
    caseTitle: 'industry.retailClientTitle',
    pectorophonyCase: 'industry.retailClientDec',
    caseImg: [
      {
        url: new URL(
          '/public/new-image/industry/retail-3.png',
          import.meta.url
        ),
        dec: '告别“滚雪球”式成本！移远OpenVending AI方案，破解无人零售成本困局',
        link: 'https://www.quectel.com.cn/news-and-pr/quectel-openvending-ai-solution',
      },
      {
        url: new URL(
          '/public/new-image/industry/retail-3.jpg',
          import.meta.url
        ),
        dec: 'MWC 2025 | 移远通信推出AI智能无人零售解决方案，以“动态视觉+边缘计算”引领智能零售新潮流',
        link: 'https://www.quectel.com.cn/news-and-pr/ai-powered-unmanned-retail-solution',
      },
    ],
  },
  Robrain: {
    name: 'industry.robrain',
    businessBg: 'industry.robrainBg',
    pectorophonyScheme: 'industry.robrainScheme',
    banner: new URL(
      '/public/image/industry_solution/robot-bg.jpg',
      import.meta.url
    ).href,
    pectorophonyImg: [
      new URL('/public/new-image/industry/Robrain-1.jpg', import.meta.url).href,
    ],
    pectorophonyScheme2:
      '在人形机器人应用场景中，该方案结合移远AI算力板QSM882GP，实现了跳舞、握手、鼓掌、点赞、比耶等动作的精准控制，显著丰富了机器人的动作表现力。在指令理解方面，无论是语音提问、文字输入，还是图片或视频内容，机器人都能准确捕捉用户意图。方案支持私有化部署专属知识库、指令库及行业大模型的深度定制，从架构层面保障数据在本地处理的安全性。联网状态下，可无缝接入豆包、DeepSeek等主流云端大模型及专业搜索工具，赋予机器人更深层的语义理解与推理能力，从而提升复杂问答交互水平。',
    pectorophonyImg2: [
      new URL('/public/new-image/industry/AI-V2.0-1.jpg', import.meta.url).href,
    ],
    pectorophonyScheme3:
      '同时，方案采用创新的端云协同架构，可实时监测网络状态，智能分配计算资源：关键指令优先在端侧处理，复杂任务则自动切换至云端，确保网络波动下的交互流畅性与数据安全。这种弹性算力架构，极大提升了机器人跨场景部署的灵活性与成本效益，加速了机器人从实验室迈向产业化。<br><br><h3 style="color: #1a1a1a">智能听觉系统：精准感知与个性安全双保障</h3><br>系统以多麦克风阵列拾音技术为基础，融合前置降噪、回声消除及波束成型算法，实现声源方向精准定位，驱动机身快速转向发声者，达成“闻声而动”的自然交互效果。在此技术基础上，系统引入声纹识别功能，构建“精准感知 + 个性服务 + 安全防护”的全链路听觉能力，大幅提升交互的智能化与安全性。<br>在复杂环境适配方面，针对商场、展馆等嘈杂场景，麦克风阵列拾音结合声纹过滤技术，可有效屏蔽环境噪音及无关人声，精准锁定已注册用户语音信号，确保人员密集场景下交互顺畅无阻。在个性化服务方面，系统支持多人声纹注册，能依据用户身份（如家庭成员、酒店VIP客户等）提供定制化服务，通过精准呼叫姓名、记忆偏好习惯等方式，赋予交互专属感，实现“贴心管家”式体验。在安全验证方面，依托声纹独特生物特征，系统可清晰区分注册用户与非注册用户，仅响应用户授权指令，例如外出场景中可规避路人误指令干扰，仅对主人声纹做出响应。',
    pectorophonyImg3: [
      new URL('/public/new-image/industry/AI-V2.0-2.jpg', import.meta.url).href,
    ],
    pectorophonyApply: [
      {
        name: '教育场景',
        dec: '可识别儿童涂鸦内容，并基于内容即兴创作趣味互动故事，有效激发儿童创造力。',
        img: new URL(
          '/public/new-image/industry/AI-V2.0-4.jpg',
          import.meta.url
        ).href,
      },
      {
        name: '零售场景',
        dec: '用户只需出示商品图片，机器人即可快速调用专属知识库，提供专业导购建议，为零售服务注入差异化优势。',
        img: new URL(
          '/public/new-image/industry/AI-V2.0-3.jpg',
          import.meta.url
        ).href,
      },
    ],
    pectorophonyCase: 'industry.robotCase',
    caseImg: [
      {
        url: new URL(
          '/public/new-image/industry/Robrain-4.png',
          import.meta.url
        ).href,
        dec: 'Robrain V2.0正式登场：落地人形机器人，引爆智能进化革命',
        link: 'https://mp.weixin.qq.com/s/1cNfjW9iJeVq3At0tq4_bQ',
      },
      {
        url: new URL(
          '/public/new-image/industry/Robrain-5.png',
          import.meta.url
        ).href,
        dec: '听得见、想得通、做得到：移远通信携手逐际动力，发布Robrain AI机器人解决方案',
        link: 'https://mp.weixin.qq.com/s/DLKBzkHguYvKwQ90kZXMRQ',
      },
      {
        url: new URL(
          '/public/new-image/industry/Robrain-6.png',
          import.meta.url
        ).href,
        dec: 'IHR 2025 | 移远通信携Robrain AI解决方案亮相，开启机器人全感官交互新纪元',
        link: 'https://mp.weixin.qq.com/s/ZZ1fJvaCRRIF-cclgXRjZg',
      },
      {
        url: new URL(
          '/public/new-image/industry/Robrain-7.png',
          import.meta.url
        ).href,
        dec: '媒体报道 | 锚定“端侧AI+机器人”，移远又有大动作！',
        link: 'https://mp.weixin.qq.com/s/6nByRL1cHkTuZaSi1zhD_A',
      },
    ],
  },
  openVend: {
    name: 'industry.openVend',
    businessBg: 'industry.openVendBg',
    pectorophonyScheme: 'industry.openVendScheme',
    banner: new URL(
      '/public/image/industry_solution/openvend.png',
      import.meta.url
    ).href,
    pectorophonyImg: [
      new URL('/public/new-image/industry/OpenVending-1.jpg', import.meta.url)
        .href,
    ],
    pectorophonyScheme2: 'industry.openVendScheme2',
    pectorophonyImg2: [
      new URL('/public/new-image/industry/OpenVending-2.jpg', import.meta.url)
        .href,
    ],
    pectorophonyScheme3: 'industry.openVendScheme3',
    pectorophonyApply: [
      {
        name: 'industry.supermarkets',
        dec: '在0.1秒内自动识别商品并同步完成称重计价，实现“即放即结”的无感结账体验，有效缓解高峰排队压力。',
        img: new URL(
          '/public/new-image/industry/OpenVending-4.jpg',
          import.meta.url
        ).href,
      },
      {
        name: 'industry.store',
        dec: '精准捕捉果蔬的颜色、形状与纹理特征，快速区分品类并自动匹配价格，实现生鲜称重从人工依赖向智能自动化升级。',
        img: new URL(
          '/public/new-image/industry/OpenVending-5.jpg',
          import.meta.url
        ).href,
      },
    ],
    caseTitle: 'industry.tianbo',
    pectorophonyCase: 'industry.openVendCase',
    caseImg: [
      {
        url: new URL(
          '/public/new-image/industry/OpenVending-3.png',
          import.meta.url
        ).href,
        dec: '0.1秒识物结账！移远通信×天波信息，联合发布OpenVending AI 解决方案',
        link: 'https://www.quectel.com.cn/news-and-pr/openvending-ai',
      },
    ],
  },
  voiceAssistant: {
    name: 'industry.voiceAssistant',
    businessBg: 'industry.voiceAssistantBg',
    pectorophonyScheme: 'industry.voiceAssistantScheme',
    banner: new URL('/public/image/assistant-banner.jpg', import.meta.url).href,
    pectorophonyImg: [
      new URL('/public/new-image/industry/Voice-1.jpg', import.meta.url).href,
      new URL('/public/image/assistant-2.png', import.meta.url).href,
    ],
    pectorophonyApply: [
      {
        name: 'industry.toy',
        img: new URL('/public/image/assistantApply1.png', import.meta.url).href,
      },
      {
        name: 'industry.base',
        img: new URL('/public/image/assistantApply2.png', import.meta.url).href,
      },
      {
        name: 'industry.learning',
        img: new URL('/public/image/assistantApply3.png', import.meta.url).href,
      },
      {
        name: 'industry.desktop',
        img: new URL('/public/image/assistantApply4.png', import.meta.url).href,
      },
    ],
    caseTitle: 'industry.voiceAssistantCaseTitle',
    pectorophonyCase: 'industry.voiceAssistantCaseDec',
    caseImg: [
      {
        url: new URL('/public/new-image/industry/Voice-2.jpg', import.meta.url)
          .href,
        dec: '',
        link: '',
      },
    ],
  },
  pectorophony: {
    name: 'AI音频模组解决方案',
    businessBg:
      '当前，语音交互是智能家居的核心竞争力，但一些传统方案依赖云端处理，存在响应延迟高、网络依赖强、隐私泄露风险等问题。移远通信 VA500-GL 模组采用本地化 AI 算法，不仅支持全离线语音唤醒与指令识别，更创新实现环境状态（安静 / 说话 / 鼾声 / 嘈杂）的离线检测，彻底摆脱对云端的依赖，引领智能家居进入 “端侧智能”主动感知新赛道。',
    pectorophonyScheme:
      'AI音频模组解决方案，集成高精度感知与智能响应能力，为各类设备提供灵敏可靠的语音交互与自动化控制支持，全面优化人机互动体验。<br><br><b style="color:#1a1a1a">主动感知环境状态：</b>通过 16kHz 高精度音频采样，可离线识别多种环境状态，联动设备自动调节运行模式。如检测到 “睡眠（鼾声）” 时，空调自动调低风速、静音并调温；空气净化器检测到无人活动（安静）自动静音或关机节能，有人说话提升速度和换气效率。<br/><br/><b style="color:#1a1a1a">离线语音控制：</b>支持定制化唤醒词与指令词，语音识别成功率超 95%，响应时间小于 100ms，65dB 背景噪声环境下指令识别准确率达 92%，用户无需联网即可极速操控。<br><br><b style="color:#1a1a1a">深度噪声抑制技术：</b>针对设备所处环境和自身运行噪声，实现 “噪声过滤”，提升语音信噪比，解决传统产品噪声干扰识别的难题。<br><br><b style="color:#1a1a1a">可靠硬件支持：</b>VA500-GL 模组稳定可靠。支持 5V 供电，可连接MIC 与扬声器（最大输出功率 2.85W），配备 2 路 UART 串口，采用 - 40~85℃宽温设计，尺寸仅 23mm×20mm×3.3mm，能集成于多种设备。',
    banner: new URL(
      '/public/image/industry_solution/voice-bg.jpeg',
      import.meta.url
    ).href,
    pectorophonyImg: [
      new URL('/public/new-image/industry/pectorophony-1.jpg', import.meta.url)
        .href,
    ],
    pectorophonyApply: [
      {
        name: '智能家居',
        dec: '应用于智能家居（如空调、空气净化器、抽油烟机、智能晾衣架、智能马桶等，可自动调节运行参数，支持离线语音控制）。',
        img: new URL(
          '/public/new-image/industry/pectorophony-2.jpg',
          import.meta.url
        ).href,
      },
      {
        name: '健康与睡眠监测设备',
        dec: '应用于健康与睡眠监测设备（如智能枕可识别鼾声联动调节环境，婴儿监护器能识别哭声报警）。',
        img: new URL(
          '/public/new-image/industry/pectorophony-3.jpg',
          import.meta.url
        ).href,
      },
    ],
    caseTitle: '',
    pectorophonyCase: '',
    caseImg: [
      {
        url: new URL(
          '/public/new-image/industry/pectorophony-4.png',
          import.meta.url
        ).href,
        link: 'https://mp.weixin.qq.com/s/Nkidu2pVF7L4XQpyya6zBQ',
        dec: '不止 “听懂”，更能 “感知”！移远通信全新AI 音频模组 重新定义智能家居“听觉”逻辑',
      },
    ],
  },
  businessRobot: {
    name: 'AI商业服务机器人解决方案',
    businessBg:
      '在AI技术加速渗透的当下，服务机器人正从“简单执行”向“智能交互”进阶，核心驱动力源于“端侧算力支撑”与“云端能力延伸”的深度协同。',
    pectorophonyScheme:
      '方案由"AI底盘控制器CR01+AI算力板AR01+AI人机交互平板P1+部署工具套件"四大模块组成，搭载"端侧智能+云端大模型"协同架构。凭借高精度自主导航系统、自然语言智能语音交互平台及优化的人机协同技术等优势，为商业服务、物品配送、AI智能客服等多元化应用场景注入智能化转型新动能。',
    pectorophonyScheme2:
      '<b style="color:#1a1a1a">AI底盘控制器CR01：自主导航的“智慧中枢”</b><br><br><div><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#1a1a1a;margin-right:10px"></span>实现机器人自主导航与定位，支持建图、路径规划与自动避障。</div><div><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#1a1a1a;margin-right:10px"></span>搭配激光雷达与移远自研视觉定位算法，适应酒店、办公室、展厅等多种场景。</div><br><b style="color:#1a1a1a">AI算力板AR01：语音交互的“超级大脑”</b><br><br><div><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#1a1a1a;margin-right:10px"></span>搭载高通QCS8550处理器，集成48 TOPS NPU算力，提供强大端侧AI算力。</div><div><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#1a1a1a;margin-right:10px"></span>构建“端侧智能+云端大模型”协同架构，兼顾本地数据处理与云端AI能力扩展。</div><div><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#1a1a1a;margin-right:10px"></span>集成全链路音频算法与多麦克风阵列拾音技术，保证机器人精准拾音与交互。</div><br><b style="color:#1a1a1a">AI人机交互平板P1：直观控的“智能窗口”</b><br><br><div><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#1a1a1a;margin-right:10px"></span>提供非语音交互控制，实现对机器人底盘的精准控制，如开启取餐舱门等操作。</div><div><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#1a1a1a;margin-right:10px"></span>搭载紫光展锐UMS9621S平台，具备优异连接能力、AI算力与多媒体性能。</div>',
    banner: '',
    pectorophonyImg: [
      new URL('/public/new-image/industry/business-1.jpg', import.meta.url)
        .href,
    ],
    pectorophonyApply: [
      {
        name: '商业服务',
        dec: '在商场、酒店、餐厅等场所，机器人可作为导购员、接待员或服务员，为顾客提供贴心服务。',
        img: new URL(
          '/public/new-image/industry/business-3.png',
          import.meta.url
        ).href,
      },
      {
        name: '物品配送',
        dec: '覆盖快递、外卖及企业内部物资运输，按预设路线精准送达，提升效率、降低人力成本。',
        img: new URL(
          '/public/new-image/industry/business-4.png',
          import.meta.url
        ).href,
      },
      {
        name: 'AI智能客服',
        dec: '依脱AI大模型的自然语言处理和理解能力，快速响应咨询与投诉，提升服务效率与质量。',
        img: new URL(
          '/public/new-image/industry/business-5.png',
          import.meta.url
        ).href,
      },
    ],
    caseTitle: '',
    pectorophonyCase: '',
    caseImg: [
      {
        url: new URL(
          '/public/new-image/industry/business-6.png',
          import.meta.url
        ).href,
        dec: '会认路、能唠嗑！移远这套方案，让AI机器人服务力直接拉满',
        link: 'https://www.quectel.com.cn/news-and-pr/quectels-overall-solution-for-ai-commercial-service-robots',
      },
      {
        url: new URL(
          '/public/new-image/industry/business-7.png',
          import.meta.url
        ).href,
        dec: '如何让AIoT设备时刻“智商在线”？移远AI太懂了！',
        link: 'https://www.quectel.com.cn/news-and-pr/2026-china-aiot-industry-annual-conference',
      },
      {
        url: new URL(
          '/public/new-image/industry/business-8.png',
          import.meta.url
        ).href,
        dec: '移路有AI | 移远通信亮相中国移动合作伙伴大会，联合发布多项5G-A×AI创新成果',
        link: 'https://www.quectel.com.cn/news-and-pr/2025-china-mobile-global-partners-conference',
      },
    ],
  },
  robotV2: {
    name: 'Robrain AI V2.0机器人解决方案',
    businessBg:
      '当AI机器人能精准捕捉指令意图，灵活响应多种交互方式，甚至能区分不同音色，一场跨越“工具”与“伙伴”的革命性进化，正由移远Robrain AI机器人解决方案V2.0版本拉开序幕。',
    pectorophonyScheme:
      '<b style="color:#1a1a1a">多模态交互：全感官协同，对话更智能</b><br><br>全新升级的Robrain V2.0深度融合多模态AI大模型，整合视觉、语音、文本等多模态数据输入，突破了单一语音交互的局限，让机器人轻松拥有场景理解、文本识别、实时图像分析等核心能力，引领行业迈入全感官交互时代。在人形机器人的应用中，Robrain V2.0结合AI算力板QSM882GP，实现了跳舞、握手、鼓掌、点赞、比耶等更精确的动作控制，让机器人的响应更加丰富多样。<br><br>不仅如此，方案对指令的理解能力更是全面跃升。无论是开口提问、文字输入，还是出示图片、展示视频，机器人都能精准捕捉你的真实意图。这背后，离不开移远打造的端云协同多模态应用方案，该方案能够精准关联不同模态输入方式，即便是复杂意图也能被轻松“读懂”。',
    pectorophonyScheme2:
      '<b style="color:#1a1a1a">个性安全双保障：让“贴心交互”更有边界</b><br><br>声纹识别功能的引入，为智能交互带来“个性 + 安全”的双重惊喜，让每一次互动都更安心、更贴心。<br><b style="color:#1a1a1a">复杂环境轻松应对</b>：在商场、展馆等嘈杂场所，麦克风阵列拾音结合声纹过滤技术，能有效屏蔽环境噪音与无关人声，精准锁定注册用户的声音，让交互始终顺畅无阻，即使人潮涌动也能“听清”用户需求。<br><b style="color:#1a1a1a">个性服务精准触达</b>：方案支持多人声纹注册，机器人能根据不同用户（如家庭成员、酒店VIP客户）提供定制化服务，如亲切叫出你的名字、牢记你的偏好习惯，让每一次交互都充满专属感，仿佛身边有位懂你的“贴心管家”。<br><b style="color:#1a1a1a">安全验证专属响应</b>：依托声纹这一独特的生物特征，机器人能清晰区分注册用户与陌生人，仅响应用户授权指令。例如，带着机器人外出时，就算路人故意喊“跟我走”，它也不会被“拐跑”，只有主人出声才会响应。',
    banner: '',
    pectorophonyImg: [
      new URL('/public/new-image/industry/AI-V2.0-1.jpg', import.meta.url).href,
    ],
    pectorophonyImg2: [
      new URL('/public/new-image/industry/AI-V2.0-2.jpg', import.meta.url).href,
    ],
    pectorophonyApply: [
      {
        name: '',
        dec: '教育场景中，它能看懂孩子的涂鸦，即兴编织趣味互动故事，激发创造力。<br>零售场景里，只需出示商品图片，它便能快速调用专属知识库，提供专业导购建议，让服务充满差异化魅力。',
        img: new URL(
          '/public/new-image/industry/AI-V2.0-3.jpg',
          import.meta.url
        ).href,
      },
    ],
    caseTitle: '',
    pectorophonyCase: '',
    caseImg: [],
  },
  robotherapist: {
    name: 'AI具身理疗机器人解决方案',
    businessBg:
      '人工智能浪潮下，具身智能正逐步从实验室构想迈向现实应用。移远通信以领先的端侧AI整体解决方案深度赋能AI机器人，覆盖工业制造、商业服务、智慧康养等领域，凭借"无人化、个性化、精准化"的技术特性，将智能理疗服务体验推向新高度。',
    pectorophonyScheme:
      '<b style="color:#1a1a1a">端侧AI技术赋能智能健康新体验</b><br><br>依托移远通信领先的端侧AI整体解决方案，AI具身机器人可在离线环境下，快速精准地理解用户的自然语言指令与意图，高效完成日常交流、健康知识问答与设备控制任务。<br><br><div><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#1a1a1a;margin-right:10px"></span><b style="color:#1a1a1a">拟人化语音交互：</b>意图识别<1秒，解码速率>15 token/s，支持中英双语，实现流畅自然的语音交互。</div><div><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#1a1a1a;margin-right:10px"></span><b style="color:#1a1a1a">多模态体征感知：</b>融合视觉、力控与红外热成像技术，实时监测用户的健康数据，为个性化理疗方案生成提供数据支撑。</div><div><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#1a1a1a;margin-right:10px"></span><b style="color:#1a1a1a">个性化方案生成：</b>结合用户实时体征与偏好，动态生成个性化的健康舒缓方案，适用于日常放松、肌肉舒缓等多种场景。</div><br><b style="color:#1a1a1a">全链路语音交互，打造自然流畅沟通体验</b><br><br>方案支持语音、视觉、文本等多模态数据输入，涵盖KWS语音唤醒、VAD人声检测、ASR语音识别及TTS语音播报。<br><br><div><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#1a1a1a;margin-right:10px"></span><b style="color:#1a1a1a">迅速响应并精准理解：</b>能准确解析如“肩颈需要深度放松20分钟”等复杂指令。</div><div><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#1a1a1a;margin-right:10px"></span><b style="color:#1a1a1a">情景化语音实时反馈：</b>设备可依据知识库进行分析，并以清晰自然的语音同步反馈执行进度与状态，营造沉浸式交互体验。</div>',
    banner: '',
    pectorophonyImg: [
      new URL('/public/new-image/industry/robotherapist-1.jpg', import.meta.url)
        .href,
    ],
    pectorophonyApply: [
      {
        name: '康复训练',
        dec: '覆盖养老院、医院康复科需求，提供穴位理疗、肢体康复训练等服务，兼顾安全防护与数据采集，减轻人力负担并辅助优化康复方案。',
        img: new URL(
          '/public/new-image/industry/robotherapist-8.png',
          import.meta.url
        ).href,
      },
      {
        name: '社区康养',
        dec: '部署于社区卫生服务中心、康养驿站等，提供肩颈调理、基础体征检测等便捷服务，缓解基层医疗人力紧张，实现 “一刻钟康养圈” 普惠体验。',
        img: new URL(
          '/public/new-image/industry/robotherapist-apply.jpg',
          import.meta.url
        ).href,
      },
      {
        name: '理疗机构',
        dec: '适配中医馆、养生馆等场所，多自由度机械臂可精准复刻专业理疗手法，以标准化服务保障效果，降低人力依赖与培训成本，助力机构扩量增效、打造差异化优势。',
        img: new URL(
          '/public/new-image/industry/robotherapist-7.png',
          import.meta.url
        ).href,
      },
    ],
    caseTitle: '',
    pectorophonyCase:
      '目前，移远端侧AI解决方案已支持德壹理疗大模型成功部署在德壹AI具身理疗机器人上，实现了丰富多样的语音控制指令，涵盖机器启停、理疗项目选择、机械臂参数调节及音量温度控制等诸多方面，后续客户还可根据实际需求运用移远工具链灵活拓展。',
    caseImg: [
      {
        url: new URL(
          '/public/new-image/industry/robotherapist-4.png',
          import.meta.url
        ).href,
        dec: '移远通信联合德壹发布全球首款搭载端侧大模型的AI具身理疗机器人',
        link: 'https://www.quectel.com.cn/news-and-pr/ai-embodied-physiotherapy-robot',
      },
      {
        url: new URL(
          '/public/new-image/industry/robotherapist-5.png',
          import.meta.url
        ).href,
        dec: '移远通信：领航AI大模型时代，驱动具身智能机器人产业未来',
        link: 'https://www.quectel.com.cn/news-and-pr/embodied-intelligent-robot',
      },
      {
        url: new URL(
          '/public/new-image/industry/robotherapist-6.png',
          import.meta.url
        ).href,
        dec: 'AI大模型端侧部署正当时：移远端侧AI大模型解决方案，激活场景智能新范式',
        link: 'https://www.quectel.com.cn/news-and-pr/quectels-edge-ai-large-model-solution',
      },
    ],
  },
  aiToys: {
    name: 'AI玩具',
    businessBg:
      '在情感消费与智能化双重驱动下，用户对AI玩具的需求不断提升。同时随着AI、大模型、多模态交互等技术的成熟与应用，AI玩具行业迎来了新的发展机遇。移远通信以“连接+AI模型+算法+物联网平台”的一站式服务，为传统智能玩具的AI升级提供支撑。',
    pectorophonyScheme: `<b style="color:#1a1a1a">稳定连接，全场景交互“不掉线”</b><br>传统智能玩具在复杂环境下容易出现断连、频繁掉线的问题。移远AI玩具解决方案可提供稳定的连接及高效的传输能力。无论在家中、商场或是户外，搭该方案的设备均可实现实时语音交互与情绪反馈，讲故事、答问题、播音乐流畅自然。<br><br><b style="color:#1a1a1a">AI大模型+音频算法，让玩具“读懂”情绪</b><br>
    传统智能玩具交互响应慢、数据同步延迟高，难以准确理解用户情绪。移远AI玩具解决方案集成云端AI大模型与全链路音频算法，让设备具备了多模态情绪识别与感知能力，能够通过语音语调、交互节奏等维度，精准感知用户情绪，并作出拟人化反馈，如语音安慰、切换音乐等，实现“听懂情绪、回应情绪”。<br><br><b style="color:#1a1a1a">loT平台赋能，加速迭代多元产品</b><br>对于终端客户来说，自建IoT平台往往面临成本高、周期长、硬件开发与平台适配脱节等问题。移远AI玩具解决方案整合“模组+AI大模型+音频算法+IoT平台”，融合Coze-RTC方案，打通传感器数据采集、存储与终端交互逻辑等环节，帮助客户大幅缩短研发周期，让“懂情绪的玩具”更快地走进用户生活。`,
    pectorophonyScheme2: '',
    banner: '',
    pectorophonyImg2: [
      new URL('/public/new-image/industry/toy-4.jpeg', import.meta.url).href,
      new URL('/public/new-image/industry/toy-5.jpeg', import.meta.url).href,
      new URL('/public/new-image/industry/toy-6.jpeg', import.meta.url).href,
    ],
    pectorophonyApply: [
      {
        name: 'industry.toy',
        dec: '能够主动倾听、感知用户情绪，带来更好的陪伴体验。',
        img: new URL('/public/image/assistantApply1.png', import.meta.url).href,
      },
      {
        name: 'industry.learning',
        dec: '拍照即识别、即时解疑，适配自主学习与家长辅导场景。',
        img: new URL('/public/image/assistantApply3.png', import.meta.url).href,
      },
      {
        name: 'industry.desktop',
        dec: '机身小巧，具备日程提醒、办公辅助、趣味互动等功能。',
        img: new URL('/public/image/assistantApply4.png', import.meta.url).href,
      },
    ],
    caseTitle: '',
    pectorophonyCase:
      '目前，移远通信AI玩具解决方案已与实丰文化、奥飞娱乐等行业伙伴深度合作并成功落地。移远通信将携手行业伙伴，以稳定连接与智能交互为基石，以情感识别与内容生态为双翼，推动玩具从“单一交互”向“全场景情感陪伴”升级，引领玩具产业迈入更智能、更温暖、更懂人性的新纪元。',
    caseImg: [
      {
        url: new URL('/public/new-image/industry/toy-2.png', import.meta.url)
          .href,
        dec: '移远通信 × 实丰文化：让玩具能听会说，更懂情绪！',
        link: 'https://www.quectel.com.cn/news-and-pr/quectel-4g-ai-toy-solution',
      },
      {
        url: new URL('/public/new-image/industry/toy-3.png', import.meta.url)
          .href,
        dec: '移远通信 × 奥飞娱乐，共同打造AI潮玩2.0时代',
        link: 'https://www.quectel.com.cn/news-and-pr/alpha-group-application-cases-of-ai-toy-solutions',
      },
      {
        url: new URL(
          '/public/image/lastest-updates/update-2.jpg',
          import.meta.url
        ).href,
        dec: '当「十万个为什么」注入移远AI灵魂：这只全时在线的小熊猫，让科普陪伴更懂孩子',
        link: 'https://www.quectel.com.cn/news-and-pr/ai-powered-intelligent-science-popularization-companion',
      },
    ],
  },
}

export { data, childItem }
